
<template>
    <div>
        <lable>VR脳トレ</lable>
    </div>
</template>
<script>
export default {
    
}
</script>